@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.HelpPopOut {
  @extend %font-family-primary;

  width: 500px;
  border-radius: 4px;
}

.Banner {
  padding: 1em 1em 0;
}

.Content {
  padding: 8px 1em 1em;
}
